import { PERMISSIONS, type Permission } from '@repo/contracts';

/**
 * Every permission this app reads. A signed-in person holding none of them
 * has nothing to see here, however many permissions they hold elsewhere.
 */
export const APP_PERMISSIONS: readonly Permission[] = [
  PERMISSIONS.projectRead,
  PERMISSIONS.clientRead,
  PERMISSIONS.allocationRead,
  PERMISSIONS.taskRead,
  PERMISSIONS.documentRead,
  PERMISSIONS.projectApprove,
  PERMISSIONS.resourceRoleRead,
];
